import { useState, useEffect, useCallback } from "react";
import tabsAccordion from "../../modules/tabs-accordion";
import ChannelItem from "../../components/channelItem/ChannelItem";
import ChannelDescription from "../../components/channelDescription/ChannelDescription";

import { HandySvg } from 'handy-svg';
import iconRightArrow from '../../assets/icons/svg-sprite/arrow-right.svg';
import iconLeftArrow from '../../assets/icons/svg-sprite/arrow-left.svg';
import iconBottomArrow from '../../assets/icons/svg-sprite/arrow-bottom.svg';

import { tv } from '../../lib/api/api';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const SputnikPackageSelection = ({basicPackage, basicChannelList, channelList}) => {
    const [categories, setCategories] = useState([]);
    const [filteredChannels, setFilteredChannels] = useState([]);
    const {name, billing_service_code, price, description, channels} = basicPackage;
    const period = {
        '30': 'мес',
        '90': '3мес',
        '180': '6мес',
        '365': 'год'
    }
    
    useEffect(() => {
        tabsAccordion.init();
        tv.channelCategories()
            .then((res) => {
                setCategories(res.categories);
                setFilteredChannels(res.categories[0].channels);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const channelFilter = useCallback(event =>
        {
            const categoryLinks = document.querySelectorAll('.package-channels__category-link');
            categoryLinks.forEach(item => item.classList.remove('package-channels__category-link--active'));
            event.target.classList.add('package-channels__category-link--active');
            const indexString = event.target.dataset.channels;
            setFilteredChannels(indexString.split(','));
        }, []);

    function getCommonElements(a, b) {
        let res = [];

        a.forEach(item => {
            let num = Number(item);
            b.forEach(elem => {
                if (num === elem) {
                    res.push(num);
                }
            });
        })
        return res;
    }

    return (
        <>
            <div className="package-selection package-selection--sputnik" id="main-tariff">
                <div className="package-selection__header">
                    <div className="package-selection__container page-container">
                        <h2 className="package-selection__title title title--h2">Ваш пакет спутникового ТВ</h2>
                    </div>
                </div>
                <div className="package-selection__body">
                    <div className="package-selection__container page-container">
                        <div className="package-selection__tabs-accordion tabs-accordion">
                            <div className="tabs-accordion__tabs">
                                <ul className="tabs-accordion__tabs-inner">
                                    <li className="tabs-accordion__tabs-item">
                                        <a className="tabs-accordion__tab" href={"#service-code_" + billing_service_code}>
                                            <div className="tabs-accordion__tab-inner">
                                                <h3 className="tabs-accordion__tab-title">{name}</h3>
                                                <span className="package-selection__channels-number">{channels}</span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <ul className="tabs-accordion__list">
                                <li className="tabs-accordion__list-item">
                                    <a className="tabs-accordion__option" href={"#service-code_" + billing_service_code}>
                                        <div className="tabs-accordion__option-inner">
                                            <h3 className="tabs-accordion__option-title">{name}</h3>
                                            <div className="tabs-accordion__option-icon">
                                                <HandySvg className="svg-icon" src={iconBottomArrow} width="20" height="20"/>
                                            </div>
                                        </div>
                                    </a>
                                    <div className="tabs-accordion__section" id={"service-code_" + billing_service_code}>
                                        <div className="tabs-accordion__section-inner">
                                            <div className="package-selection__section-wrapper">
                                                <div className="package-selection__section-footer">
                                                    <div className="package-selection__price">
                                                        <div className="package-selection__price-value">
                                                            <span className="number number--md">{price.rubles}<span className="number__units">Р/{period[price.days]}</span></span>
                                                        </div>
                                                        <span className="package-selection__price-note">по программе <a className="link" href="javascript:void(0)">«Телекарта Бонус»</a></span>
                                                    </div>
                                                    <button className="package-selection__choose-btn solid-btn solid-btn--blue solid-btn--lg bttn" type="button" disabled>Текущий тариф</button>
                                                </div>
                                                <div className="package-selection__section-body">
                                                    <div dangerouslySetInnerHTML={{ __html: description }} />
                                                    <div className="package-channels">
                                                        <ul className="package-channels__categories package-channels__categories-slider">
                                                            <button className="js-package-channels__categories-slider-prev-btn js-package-channels__categories-slider-btn js-package-channels__categories-slider-btn--prev bttn" type="button">
                                                                <HandySvg className="svg-icon" src={iconLeftArrow} width="16" height="16"/>
                                                            </button>
                                                            <div className="js-package-channels__categories-slider-wrapper">
                                                                <Swiper
                                                                    slidesPerView={'auto'}
                                                                    className="package-channels__categories-inner"
                                                                    modules={[Navigation]}
                                                                    navigation={{
                                                                        prevEl: '.js-package-channels__categories-slider-prev-btn',
                                                                        nextEl: '.js-package-channels__categories-slider-next-btn',
                                                                    }}
                                                                >
                                                                    <SwiperSlide className="package-channels__category">
                                                                        <a className="package-channels__category-link" data-channels={basicChannelList} onClick={channelFilter} href="javascript:void(0)">Все</a>
                                                                    </SwiperSlide>
                                                                    {categories.map((category, index) => (
                                                                        <SwiperSlide className="package-channels__category">
                                                                            <a className={(index === 0 ? "package-channels__category-link--active " : "") + "package-channels__category-link"} data-channels={category.channels} onClick={channelFilter} href="javascript:void(0)">{category.name}</a>
                                                                        </SwiperSlide>
                                                                    ))}
                                                                </Swiper>
                                                            </div>
                                                            <button className="js-package-channels__categories-slider-next-btn js-package-channels__categories-slider-btn js-package-channels__categories-slider-btn--next bttn" type="button">
                                                                <HandySvg className="svg-icon" src={iconRightArrow} width="16" height="16"/>
                                                            </button>
                                                        </ul>
                                                        <div className="package-channels__list-wrapper">
                                                            <ul className="package-channels__list">
                                                                {getCommonElements(filteredChannels, basicChannelList).map(channel => (
                                                                    <ChannelItem channel={channel} channelList={channelList}/>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                        <div className="tooltipster-templates">
                                                            {getCommonElements(filteredChannels, basicChannelList).map(channel => (
                                                                <ChannelDescription channel_id={channel}/>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SputnikPackageSelection;